import { render, staticRenderFns } from "./#detail.vue?vue&type=template&id=7c832836&"
import script from "./#detail.vue?vue&type=script&lang=js&"
export * from "./#detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports